function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var Accordion = /*#__PURE__*/ function() {
    "use strict";
    function Accordion() {
        _class_call_check(this, Accordion);
        _define_property(this, "$root", document.querySelector('[data-accordion-root]'));
        _define_property(this, "$item", document.querySelectorAll('[data-accordion-item]'));
        _define_property(this, "$title", document.querySelectorAll('[data-accordion-title]'));
        _define_property(this, "$clear", document.querySelector('[data-accordion-clear]'));
        _define_property(this, "$images", document.querySelectorAll('.buy__preview img'));
    }
    _create_class(Accordion, [
        {
            key: "handleClear",
            value: function handleClear() {
                this.$item.forEach(function($item) {
                    $item.classList.remove('-show');
                });
                this.$root.classList.remove('-active');
            }
        },
        {
            key: "handleRootClass",
            value: function handleRootClass() {
                var active = false;
                this.$item.forEach(function($item) {
                    if ($item.classList.contains('-show')) active = true;
                });
                if (active) this.$root.classList.add('-active');
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                var _this_$title, _this_$clear;
                (_this_$title = this.$title) === null || _this_$title === void 0 ? void 0 : _this_$title.forEach(function($item, index) {
                    $item.addEventListener('click', function() {
                        $item.closest('[data-accordion-item]').classList.toggle('-show');
                        _this.handleRootClass();
                        _this.$images.forEach(function($image, imageIndex) {
                            $image.classList.toggle('-active', index === imageIndex);
                        });
                    });
                });
                (_this_$clear = this.$clear) === null || _this_$clear === void 0 ? void 0 : _this_$clear.addEventListener('click', function(event) {
                    event.preventDefault();
                    _this.handleClear();
                });
            }
        }
    ]);
    return Accordion;
}();
export default Accordion;
